import { getTrendingFeedData, getVideoById } from "@/api";
import { redirect } from "@sveltejs/kit";
import constants from "@/constants";
import { isBrowser } from "@/utils/helpers/utils";
import { goto } from "@/utils/navigationUtils";
const { NOT_FOUND_URL } = constants;
import { sanitizeString } from "@mohalla-tech/xss-safeguard";
import type { AnyObject } from "@/types/Any";

export const ssr = true;

export const load = async ({
  params,
  fetch,
}: {
  params: AnyObject;
  fetch: AnyObject;
}) => {
  let { videoId } = params;
  videoId = sanitizeString(videoId);
  try {
    const data: AnyObject = await getVideoById(fetch, videoId);
    if (data.isDeleted || data.err || data.isPrivate) {
      if (isBrowser) return await goto(NOT_FOUND_URL);
      else throw redirect(302, NOT_FOUND_URL);
    } else {
      return {
        videoId,
        item: data,
      };
    }
  } catch (e) {
    return {
      videoId,
    };
  }
};
